<template>
  <div v-if="!loaded" id="loaderWrapper">
    <img class="h-12 md:h-13 lg:h-14 xl:h-16" src="@/assets/logo.png" alt="EASY" />
    <h1 id="loader" class="text-accent my-1 lg:my-2 xl:my-4 text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl uppercase">
      Chargement... 0%
    </h1>
  </div>
</template>

<script>
import Assets from '../utils/webgl/Assets.js';

export default {
  name: 'Loader',
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    const assets = new Assets();
    if (assets.assetsAlreadyLoaded) {
      this.$emit('loadend');
      this.loaded = true;
      return;
    }

    let loadCount = 0;
    let elementsToLoad = 44; // 38 color choices + 4 floors + 1 GLB model + 1 logo
    const local = this;
    const loader = document.getElementById('loader');

    function newLoad() {
      loadCount += 1;

      loader.innerText = `Chargement... ${Math.round((loadCount / elementsToLoad) * 100)}%`;

      if (loadCount === elementsToLoad) {
        assets.assetsAlreadyLoaded = true;
        local.$emit('loadend');

        document.getElementById('loaderWrapper').style.opacity = 0;
        setTimeout(() => {
          local.loaded = true;
        }, 500);
      }
    }
    assets.newLoad = newLoad;
  },
};
</script>

<style scoped>
#loaderWrapper {
  position: absolute;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background-color: white;
  transition-duration: 500ms;
  z-index: 10;
}
</style>
